var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoTitle"},[_c('router-link',{attrs:{"to":{name:'dashboard'}}},[_c('div',[(_vm.showTitle)?_c('h1',[_vm._v("专家管理系统")]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }